import React from 'react';
import {
  Text, Center, SegmentedControl, useMantineColorScheme, useMantineTheme,
} from '@mantine/core';
import { IconMoonStars, IconSun } from '@tabler/icons';

export const ToggleColorScheme: React.FC = () => {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const theme = useMantineTheme();

  return (
    <SegmentedControl
      value={colorScheme}
      onChange={() => {
        toggleColorScheme();
      }}
      fullWidth
      styles={{
        label: {
          paddingTop: 5,
          paddingBottom: 5,
          fontWeight: 400,
        },
        root: {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        },
        active: {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[0],
        },
      }}
      size="sm"
      data={[
        {
          label: (
            <Center>
              <IconSun size={14} />
              <Text ml={10}>Light</Text>
            </Center>
          ),
          value: 'light',
        },
        {
          label: (
            <Center>
              <IconMoonStars size={14} />
              <Text ml={10}>Dark</Text>
            </Center>
          ),
          value: 'dark',
        },
      ]}
    />
  );
};
